import BaseApiService from './base/base-api-service'
import type { DeparturesResponse, DepartureSearchResult } from '../types'
import { Terminal } from './../types/enums'

/**
 * Represents the Departures API service.
 */
export default class DeparturesService extends BaseApiService {
  constructor(baseUrl: string) {
    super(baseUrl)
  }

  /**
   * Gets departures.
   * @param {Terminal} terminal - The terminal to fetch departures for.
   * @param {number} maxResults - The maximum number of results to fetch.
   * @returns {Promise<DeparturesResponse>} Departures API response.
   */
  public async GetDepartures(
    terminal: Terminal,
    maxResults: number
  ): Promise<DeparturesResponse> {
    return await this.GetAsync<DeparturesResponse>(
      `api2/departures?terminal=${terminal}&maxResults=${maxResults}`
    )
  }

  /**
   * Searches departures.
   * @param {Terminal} terminal - The terminal to fetch departures for.
   * @param {string} letter - The departure letter.
   * @returns {Promise<DepartureSearchResult>} Departure search API response.
   */
  public async SearchDepartures(
    terminal: Terminal,
    letter: string
  ): Promise<DepartureSearchResult | null> {
    try {
      return await this.GetAsync<DepartureSearchResult>(
        `api2/departures/search?terminal=${terminal}&letter=${letter}`
      )
    } catch (excp: unknown) {
      if (excp instanceof Error) {
        // @ts-ignore: 'Error' constructor arguments
        switch (excp.cause) {
          case 404:
            return null
          case 503:
            console.error('Departures search service is currently unavailable.')
            return null
          default:
            console.error(
              'An unexpected error occurred whilst searching departures.'
            )
            return null
        }
      }

      return null
    }
  }
}
